import Cookies from 'js-cookie'
import { merge, isEmpty } from '@/utils'
import { getUserAgent } from '@/utils/dom'
import { SENSORS_TRACK_URL, Y } from '@/common/const'
const sa_name = 'sa'
const ua = getUserAgent()
const show_log = process.env.VUE_APP_SHOW_SENSOR_LOG === Y

const defaultOptions = {
    'heatmap_url': 'https://pssweb.ppdai.com/loanapp/util/heatmap.min.js',
    'sdk_url': 'https://pssweb.ppdai.com/loanapp/util/sensorsdata.min.js',
    'name': 'sa',
    'encrypt_cookie': true,
    'is_secure_cookie': true, // 神策cookie增加secure配置
    'server_url': `https://sensorsdata.ppdai.com/sa/?project=${process.env.VUE_APP_SA_PROJECT}`,
    show_log
}
const getSaInstance = para => {
    const p = para.sdk_url
    const n = para.name
    const w = window
    const d = document
    const s = 'script'
    let x = null
    let y = null

    if (w[n]) {
        return
    }

    w['sensorsDataAnalytic201505'] = n

    w[n] =
        w[n] ||
        function (a) {
            return function () {
                (w[n]._q = w[n]._q || []).push([a, arguments])
            }
        }

    const ifs = [
        'track',
        'quick',
        'register',
        'registerPage',
        'registerOnce',
        'clearAllRegister',
        'trackSignup',
        'trackAbtest',
        'setProfile',
        'setOnceProfile',
        'appendProfile',
        'incrementProfile',
        'deleteProfile',
        'unsetProfile',
        'identify',
        'login',
        'logout',
        'trackLink',
        'clearAllRegister'
    ]

    for (let i = 0; i < ifs.length; i++) {
        w[n][ifs[i]] = w[n].call(null, ifs[i])
    }

    if (!w[n]._t) {
        x = d.createElement(s)
        y = d.getElementsByTagName(s)[0]
        x.async = 1
        x.src = p
        y.parentNode.insertBefore(x, y)
        w[n].para = para
    }

    return w[n]
}

const isBuiltInComponent = vnode => {
    if (!vnode) {
        return false
    }
    const { tag } = vnode.componentOptions
    return /keep-alive|transition|transition-group/.test(tag)
}

export default {
    'install': (Vue, options) => {
        options = merge(defaultOptions, options)
        const sa = getSaInstance(options)
        if (!sa) {
            return
        }
        let source

        if (ua.mobile) {
            source = ua.weixin ? 'weixin' : ua.qq ? 'qq' : 'mobile'
        } else {
            source = 'pc'
        }

        const openId = Cookies.get('openid')

        if (!isEmpty(openId)) {
            sa.login(openId)
        }
        sa.registerPage({
            'product': 'other',
            'product_h5': 'superloan_h5',
            'h5_channel': Cookies.get('regSourceId'),
            'user_agent': navigator.userAgent,
            'source': source,
            'platform': 'h5',
            'openid': openId
        })
        sa.quick('autoTrack')
        Vue.mixin({
            provide () {
                if (this.$sa && !isBuiltInComponent(this.$vnode)) {
                    return {
                        '$sa': this.$sa
                    }
                }
                return {}
            },

            beforeCreate () {
                if (!this.$sa) {
                    this.$sa = sa
                }
            }
        })
    }
}
